import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'

import NavigationHelper from 'layers/navigation/navigationHelper'
import SubNavGetter, {
  SubNavGetterComponentPropTypes,
} from 'layers/content/v2/Hocs/SubNavGetter'
import {
  getThemeFromUrl,
  getProductFromUrl,
  resolveRouteServiceApp,
} from 'utils/productHelpers'
import { selectors as licenseSelectors } from 'store/licenseManager'
import { isFlagOn } from 'utils/featureFlags'
import { FLAG_CORE_LESSON_COMPLETION_UPDATES } from 'components/AdminDashboardBanner/constants'

import Component from './component'

function NavigationContainer(props) {
  const theme = getThemeFromUrl()
  const productConfig = getProductFromUrl()

  return <Component product={productConfig} theme={theme} {...props} />
}

const navigationConnect = connect(
  NavigationHelper.mapStateToProps,
  NavigationHelper.mapDispatchToProps,
)

const userConnect = connect(state => {
  const { userAccessManager } = state || {}
  const { claims } = userAccessManager || {}
  const { userProfileManager } = state || {}
  const { profile } = userProfileManager || {}
  const { firstName = '', lastName = '', roles = [] } = profile || {}
  const hasStandaloneDwbAccess =
    isFlagOn([FLAG_CORE_LESSON_COMPLETION_UPDATES]) &&
    licenseSelectors.selectActiveAdminStandaloneDwbSites(state).length > 0

  return {
    roles,
    userClaims: claims,
    name: `${firstName} ${lastName}`.trim(),
    hasStandaloneDwbAccess,
  }
})

NavigationContainer.propTypes = {
  subNavData: SubNavGetterComponentPropTypes,
}

const subNavGetterOptions = {
  app: () => resolveRouteServiceApp(window.location.pathname),
}

export default compose(
  navigationConnect,
  userConnect,
)(SubNavGetter(NavigationContainer, subNavGetterOptions))
